import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Fish, LogOut, Shield } from 'lucide-react';

const Header = () => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <Fish className="w-10 h-10" />
            <div>
              <h1 className="text-2xl font-bold">Fishing Tracker Pro</h1>
              <p className="text-blue-100 text-sm">Mauritius Edition</p>
            </div>
          </Link>

          <div className="flex items-center gap-4">
            {user?.is_admin && (
              <Link
                to="/admin"
                aria-label="Admin"
                className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors"
              >
                <Shield className="w-4 h-4" aria-hidden="true" />
                <span className="hidden md:inline">Admin</span>
              </Link>
            )}
            <Link
              to="/profile"
              aria-label="Profile"
              title="Edit your profile"
              className="flex items-center gap-2 hover:bg-white/20 px-2 py-1 rounded-lg transition-colors"
            >
              {user?.avatar_url ? (
                <img src={user.avatar_url} alt={user.username} className="w-10 h-10 rounded-full border-2 border-white" />
              ) : (
                <div className="w-10 h-10 bg-white/30 rounded-full flex items-center justify-center border-2 border-white">
                  <span className="text-sm font-bold">
                    {user?.username?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase() || 'U'}
                  </span>
                </div>
              )}
              <div className="hidden md:block">
                <p className="font-semibold">{user?.username}</p>
                <p className="text-xs text-blue-100">{user?.email}</p>
              </div>
            </Link>

            <button
              onClick={logout}
              aria-label="Logout"
              className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors"
            >
              <LogOut className="w-4 h-4" aria-hidden="true" />
              <span className="hidden md:inline">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;